import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { EventLink } from "@companion-core/shared/app/Components/EventLink";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import { NavLinkItem } from "@companion-core/shared/app/Interfaces/navigation";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { getLocales } from "@companion-core/shared/app/Utils/config";

const Footer = () => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const { t } = useTranslation();
  const { config, branding } = useConfigStore((state) => ({
    config: state.config,
    branding: state.branding,
  }));
  const logoUri = useMemo(() => branding?.theme?.assets?.logo?.footer, [branding]);
  const footerLinks = useMemo(() => config?.options?.footerLinks, [config]);
  const localesCount = getLocales().length;

  if (isMobileSize) {
    return <></>;
  }

  return (
    <div className="footer">
      <div className="footer__links body-text-8">
        {footerLinks?.map(({ name, type, link, path }: NavLinkItem) => (
          <EventLink
            data-testid={`footer__link--${name}`}
            key={name}
            name={name}
            type={type}
            link={link}
            path={path}>
            {t(`common.links.${name}`)}
          </EventLink>
        ))}
      </div>

      {localesCount > 1 && (
        <div className="footer__language-switcher">
          <LanguageSwitcher />
        </div>
      )}

      {/* Logo container */}
      <img data-testid="footer__logo" className="footer__logo" src={logoUri} alt="logo" />
    </div>
  );
};

export default Footer;
